import api from '../../../lib/api';
import type {
  CalendarEvent,
  CalendarEventNote,
  CreateCalendarEventPayload,
  UpdateCalendarEventPayload,
} from '../../../types/calendar';
import type { CalendarEventsDateRange } from '../utils/calendarViewRange';

// Thin, typed wrapper over the shared axios instance (src/lib/api.ts) — same
// client every other feature uses, not a separate networking mechanism.
// Mirrors the backend's CalendarController route shapes 1:1.
export const calendarAPI = {
  // `range` is optional and both-or-neither on the backend (see
  // ListCalendarEventsQueryDto) — omitting it lists every event for the
  // organization, unfiltered.
  listEvents: (organizationId: string, range?: CalendarEventsDateRange) =>
    api.get<CalendarEvent[]>('/calendar/events', { params: { organizationId, ...range } }),
  createEvent: (payload: CreateCalendarEventPayload) =>
    api.post<CalendarEvent>('/calendar/events', payload),
  updateEvent: (id: string, organizationId: string, payload: UpdateCalendarEventPayload) =>
    api.patch<CalendarEvent>(`/calendar/events/${id}`, payload, { params: { organizationId } }),
  cancelEvent: (id: string, organizationId: string, reason?: string) =>
    api.post<CalendarEvent>(
      `/calendar/events/${id}/cancel`,
      { reason },
      { params: { organizationId } },
    ),
  addNote: (id: string, organizationId: string, content: string) =>
    api.post<CalendarEventNote>(
      `/calendar/events/${id}/notes`,
      { content },
      { params: { organizationId } },
    ),
};
